<template>
  <CustomCreateDialog
    dialogTitle="شروع کلاس ترمیک"
    dialogId="start-termic-course-confirmation-dialog"
    okTitle="بله"
    cancelTitle="خیر"
    :isOkDisabled="isLoading"
    @ok="startTermicCourseByAdmin"
  >
    <BCol cols="12">
      <p>
        آیا از شروع کلاس ترمیک
        <span style="font-weight: bold">{{
          termicCourseDetails && termicCourseDetails.termicCourseName
            ? termicCourseDetails.termicCourseName
            : ""
        }}</span>
        اطمینان دارید؟
      </p>
    </BCol>
  </CustomCreateDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    termicCourseDetails: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async startTermicCourseByAdmin() {
      try {
        this.isLoading = true;
        const _this = this;
        const startTermicCourse = new StartTermicCourse(_this);
        startTermicCourse.setRequestParam({
          termicCourseId: this.termicCourseDetails.id,
        });
        await startTermicCourse.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "شروع شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "وضعیت کلاس ترمیک به در حال برگزاری تغییر کرد.",
              },
            });
            this.$bvModal.hide("start-termic-course-confirmation-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CustomCreateDialog,
    BCol,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { StartTermicCourse } from "@/libs/Api/TermicCourses";
import { BCol } from "bootstrap-vue";
</script>
